import { useAccountList } from '@ltvco/refresh-lib/hooks';
import { AccountListsV2 } from '@ltvco/refresh-lib/v1';
import { ListLandingPage } from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useEffect } from 'react';

export function Lists() {
  const { data: lists, isLoading } = useAccountList();
  const isInListV2Variation = useFeatureIsOn('prop-2834');

  useEffect(() => {
    document.title = 'Report Lists - BeenVerified';
  }, []);

  if (isInListV2Variation) {
    return <ListLandingPage lists={lists || []} isLoading={isLoading} />;
  }

  return <AccountListsV2 lists={lists || []} isLoading={isLoading} />;
}
